import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Contact from "../pages/contact/page";
import HowItWorks from "../pages/how-it-works/page";
import SeasideOffers from "../pages/seaside-offers/page";
import StartSaving from "../pages/start-saving/page";
import LeisureHomeSales from "../pages/leisure-home-sales/page";
import Accommodation from "../pages/accommodation/page";
import PropertyDetails from "../pages/property-details/page";
import BusinessRegistration from "../pages/business-registration/page";
import VoucherBook from "../pages/voucher-book/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/how-it-works",
    element: <HowItWorks />,
  },
  {
    path: "/seaside-offers",
    element: <SeasideOffers />,
  },
  {
    path: "/voucher-book",
    element: <VoucherBook />,
  },
  {
    path: "/leisure-home-sales",
    element: <LeisureHomeSales />,
  },
  {
    path: "/property/:id",
    element: <PropertyDetails />,
  },
  {
    path: "/accommodation",
    element: <Accommodation />,
  },
  {
    path: "/start-saving",
    element: <StartSaving />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/business-registration",
    element: <BusinessRegistration />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
